import { FC, useEffect } from 'react';
import { useAppDispatch } from 'src/modules/shared/hooks/useAppDispatch';
import { setNavigationPlace } from 'src/modules/shared/slices/navigationBar/navigationBarSlice';

export const TrajectoryNavBar: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setNavigationPlace('trajectory'));
  }, [dispatch]);

  useEffect(
    () => () => {
      dispatch(setNavigationPlace(null));
    },
    [dispatch]
  );

  return null;
};
